import request from '@/utils/axios'
import qs from 'qs'

/**
 * 获取格式化校区列表
 * @param {*} params 
 */
export function getFormatSchoolInfo(param) {
    // let data = qs.stringify(params)
    return request({
        url: '/api/manager/school/getAllSchoolInfo',
        method: 'get',
        params: param
    })
}

/**
 * 获取校区列表
 * @param {*} params 
 */
export function getSchoolInfo(params) {
    let data = qs.stringify(params)
    return request({
        url: '/api/manager/school/getSchoolInfo',
        method: 'post',
        data: data
    })
}

/**
 * 删除校区
 * @param {*} params 
 */
export function deleteSchool(params) {
    let data = qs.stringify(params)
    return request({
        url: '/api/manager/school/deleteSchool',
        method: 'post',
        data: data
    })
}

/**
 * 添加校区
 * @param {*} params 
 */
export function addSchool(params) {
    let data = qs.stringify(params)
    return request({
        url: '/api/manager/school/addSchool',
        method: 'post',
        data: data
    })
}

/**
 * 修改校区
 * @param {*} params 
 */
export function editSchool(params) {
    let data = qs.stringify(params)
    return request({
        url: '/api/manager/school/editSchool',
        method: 'post',
        data: data
    })
}